
import { IActRejectionDTO, IActRejectionViewDTO } from "../../coreapi-dto/documents/ActRejection";
import { ContentType } from "../../fetchApiDistributor/contentTypes";
import { CoreApiResponse, IRequestEventHandler } from "../common";
import { BaseDirRequest } from "../dirs/baseDirRequest";

class ActRejectionRequest extends BaseDirRequest<IActRejectionViewDTO, IActRejectionDTO> {

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl, "RejectionAct", token, eventHandler)
    }

    getView(body: IViewBody, callback?: (e: CoreApiResponse<IViewWrapper<IActRejectionViewDTO>>) => void) {
        this.post<IViewWrapper<IActRejectionViewDTO>>(`${this._baseUrl}/${this._routePrefix}/view`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }

    getItemById(id: string, body: IViewBody, callback?: (e: CoreApiResponse<IViewWrapper<IActRejectionDTO>>) => void) {
        this.post<IViewWrapper<IActRejectionDTO>>(`${this._baseUrl}/${this._routePrefix}/${id}/Item/View`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }
}
export default ActRejectionRequest